module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.marker) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup__details"
  }, [_c('div', {
    staticClass: "popup__close icon-close",
    on: {
      "click": function($event) {
        _vm.closePopup(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup__top"
  }, [_c('div', {
    staticClass: "popup__header"
  }, [(_vm.marker.name) ? _c('div', {
    staticClass: "popup__name"
  }, [_vm._v(_vm._s(_vm.marker.name))]) : _vm._e(), _vm._v(" "), (_vm.marker.distance) ? _c('div', {
    staticClass: "popup__distance"
  }, [_vm._v(_vm._s(_vm.marker.distance.replace('.', ',')) + " " + _vm._s(_vm.$t('matrix')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "popup__contact"
  }, [_c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [_vm._v(_vm._s(_vm.marker.address))]), _vm._v(" "), _c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [(_vm.marker.zipcode) ? _c('span', [_vm._v(_vm._s(_vm.marker.zipcode) + ",")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.marker.city))]), _vm._v(" "), _c('div', {
    staticClass: "popup__location",
    attrs: {
      "if": "marker.address"
    }
  }, [_vm._v(_vm._s(_vm.marker.state))]), _c('br'), _vm._v(" "), (_vm.phone) ? _c('div', [_vm._v(_vm._s(_vm.phone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "popup__bottom"
  }, [(_vm.hours) ? _c('div', {
    staticClass: "popup__opening_hours"
  }, [_c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('monFri')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[1]) ? _c('span', [_vm._v(_vm._s(_vm.hours[1].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[1].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('sat')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[6]) ? _c('span', [_vm._v(_vm._s(_vm.hours[6].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[6].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup__open"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('sun')))]), _vm._v(" "), _c('div', {
    staticClass: "popup__hour"
  }, [(_vm.hours[0]) ? _c('span', [_vm._v(_vm._s(_vm.hours[0].open.slice(0, 2)) + " - " + _vm._s(_vm.hours[0].close.slice(0, 2)))]) : _c('span', [_vm._v(_vm._s(_vm.$t('closed')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup__links"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.$t('directions')))])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-feaf5034"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/Popup.vue
// module id = 418
// module chunks = 1